import datos from "src/services/datos";
import Swal from "sweetalert2";
import esArray from "src/general_components/functionEsArray";

const tipoUbicaciones = new datos("tipo_ubicaciones");

export const getTipoUbicaciones = async (auth) => {
  tipoUbicaciones.addCondition("tipo_ubicaciones", "id", 0, ">");
  const response = await tipoUbicaciones.get();
  const arrResponse = esArray(response.wsResponse?.tipo_ubicaciones)
  return arrResponse;
};

export const getTipoUbicacionesPaginated = async (limit, offset) => {
  tipoUbicaciones.addCondition("tipo_ubicaciones", "id", 0, ">");
  tipoUbicaciones.addLimitCondition(limit, offset);
  const response = await tipoUbicaciones.get();
  /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

  let result = {};
  if (!response.wsResponse.empty) {
    let arrResponse = esArray(response.wsResponse.tipo_ubicaciones)
    result = {
      data: arrResponse,
      total_records: response.wsResponse.total_records,
    };
    return result;
  }
};

export const postTipoUbicaciones = async (tipo_ubicaciones) => {
  const response = tipoUbicaciones.insert(tipo_ubicaciones);
  return response;
};

export const deleteTipoUbicaciones = async (id) => {
  let status = false;
  await Swal.fire({
    title: "Esta seguro de que desea eliminar este tipo de ubicacion?",
    text: "Si sigue adelante, no se podran revertir los cambios!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, quiero eliminarlo!",
    cancelButtonText: "No, no estoy seguro!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      const tipoUbicaciones = new datos("tipo_ubicaciones");
      let data = {
        id: id,
      };
      const response = await tipoUbicaciones.delete(data);

      if (response.status === "true") {
        status = true;
        await Swal.fire(
          "Eliminado!",
          "El tipo de ubicacion ha sido eliminado exitosamente",
          "success"
        );
      } else {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message,
        });
      }
    }
  });
  return status;
};
